export default __webpack_public_path__ + "static/media/CNo.67-3.55b00198.jpg";